export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8959.54e7e850.jpg";